import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SuperuserSideBar from '../Components/SuperuserSideBar';
import TenantManager from '../Superuser/TenantManager';
import SubscriptionManager from '../Superuser/SubscriptionManager';
import CourseManager from '../Common/CourseManager';
import ReviewCourseTerms from '../Common/ReviewCourseTerms';
import PrivateContentLayout from '../Common/PrivateContentLayout';
import BackgroundJobsView from '../Superuser/BackgroundJobsView';
import ReviewTenant from '../Superuser/ReviewTenant';
import AdminCreator from '../Superuser/AdminCreator';

const SuperRouter = () => {

    return (
        <Box >
  
          {/* Sidebar with fixed width */}
            <SuperuserSideBar />
            <PrivateContentLayout >
          {/* Main content area with flexible width */}
          <Box overflowY="auto">
            <Routes>
              <Route path="/" element={<Navigate to="tenant-manager" />} />
              <Route path="tenant-manager" element={<TenantManager />} />
              <Route path="tenant-manager/review-tenant/:tenant_id" element={<ReviewTenant />} />
              <Route path="subscription-manager" element={<SubscriptionManager />} />
              <Route path="admin-manager" element={<AdminCreator />} />
              <Route path="course-manager" element={<CourseManager />} />
              <Route path="course-manager/review-course/:course_id" element={<ReviewCourseTerms />} />
              <Route path="scheduler-jobs" element={< BackgroundJobsView/>} />
              {/* <Route path="change-password" element={<ChangePassword />} /> */}
            </Routes>
          </Box>
          </PrivateContentLayout>

      </Box>
    );
  };

export default SuperRouter;
